import React from "react";
import { Col, Row } from "antd";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import "./news.css";
import { useNavigate } from "react-router-dom";

const News = () => {
  const navigate = useNavigate();

  const newsItem = [
    { name: "News Title" },
    { name: "News Title" },
    { name: "News Title" },
    { name: "News Title" },
    { name: "News Title" },
    { name: "News Title" },
    { name: "News Title" },
  ];

  const handleMenuClick = (e: any) => { };

  const items = [
    {
      label: "Edit News",
      key: "1",
      icon: <UserOutlined />,
    },
    {
      label: "Copy Link",
      key: "2",
      icon: <UserOutlined />,
    },
    {
      label: "Duplicate",
      key: "3",
      icon: <UserOutlined />,
    },
    {
      label: "Download",
      key: "4",
      icon: <UserOutlined />,
    },
    {
      label: "Rename",
      key: "5",
      icon: <UserOutlined />,
    },
    {
      label: "Delete",
      key: "6",
      icon: <UserOutlined />,
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <div>
      <div className="news_header">
        <h1 className="news_title">Your Created Smart News</h1>
        <div className="news_buttons">
          <button
            className="btn_news"
            onClick={() => navigate("/create-video")}
          >
            Create New Template
          </button>
          <button
            className="btn_news"
            onClick={() => navigate("/create-video-template")}
          >
            Create Video With Template
          </button>
        </div>
      </div>
      <div className="news_list">
        <Row gutter={[16, 16]} justify="center">
          {newsItem.map((item: any, index: number) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <div className="outer_news">
                <img src="news.jpg" alt={item.name} className="news_image" />
                <div className="news_body">
                  <h3>{item.name}</h3>
                  <Dropdown menu={menuProps}>
                    <Button>
                      <Space>
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default News;
